import PropTypes from 'prop-types';
import React from 'react';

import Classes from 'classnames';
import _ from 'lodash';

class InlineTexarea extends React.Component {
    static propTypes = {
        value: PropTypes.string,
        disabled: PropTypes.bool,
        placeholder: PropTypes.string,
        onFocus: PropTypes.func,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        commitDelay: PropTypes.number,
        onImmediateChange: PropTypes.func,

        rows: PropTypes.number,
        maxRows: PropTypes.number,
        cols: PropTypes.number
    };

    static defaultProps = {
        disabled: false,
        commitDelay: 600,
        rows: 2,
        cols: 50
    };

    state = {
        value: this.props.value,
        rows: this.props.rows,
        cols: this.props.cols,
        // isFocused: false
    };

    UNSAFE_componentWillMount() {
        this.commited = true;
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.commited && this.state.value !== newProps.value)
            this.setState({value: newProps.value});
    }

    componentDidMount() {
        this.calculateToFit();
        this.debounceOnChange = _.debounce(this.commitOnChange, this.props.commitDelay);
    }

    componentDidUpdate() {
        this.calculateToFit();
    }

    commitOnChange = (newValue) => {
        this.commited = true;
        if (this.props.onChange) this.props.onChange(newValue ? newValue.trim() : newValue);
    };

    calculateToFit = () => {

        if (!this.refs.textarea) return false; // disabled mode = not textarea

        const { maxRows } = this.props;
        let str = this.state.value ? this.state.value : "";
        let newCols = this.refs.textarea.cols;

        let linecount = 0;
        str.split("\n").map((l)=>{
            linecount += Math.ceil( l.length / newCols ); // Take into account long lines
            if (l.length === 0) linecount++;
        });

        let newRows = linecount /*+ 1*/;
        if ( maxRows && maxRows < newRows) newRows = maxRows;

        const { rows, cols } = this.state;
        if (rows !== newRows || cols !== newCols){
            this.setState({rows:newRows, cols:newCols});
        }
    };

    onFocus = (e) => {
        const { onFocus } = this.props;
        if (onFocus) onFocus(e);

        // this.setState({
        //     isFocused: true
        // });
    };

    onBlur = (e) => {
        const { onBlur } = this.props;
        if (onBlur) onBlur(e);
        this.debounceOnChange.cancel();
        this.commitOnChange(this.state.value);
    };

    onChange = (event) => {
        this.commited = false;
        const newValue = event.target.value;
        this.debounceOnChange(newValue);
        this.setState({value:newValue}, ()=>{
            if (this.props.onImmediateChange) this.props.onImmediateChange(newValue);
        });
    };

    render() {
        const { disabled, placeholder, className } = this.props;
        const { value, rows, cols } = this.state;

        const classes = Classes('gd-inline-textarea',className, {
            disabled: disabled,
            empty: !value
        });

        if (disabled) {
            return (
                <div className={classes}>{value}</div>
            );
        }

        return (
            <textarea ref="textarea"
                      rows={rows} cols={cols}
                      spellCheck="false"
                      className={classes}
                      placeholder={placeholder}
                      value={value ? value : ""}
                      disabled={disabled}
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onChange={this.onChange}/>
        );
    }
}

module.exports = InlineTexarea;